<template>
    <div class="vs-row custom-pagination" style="justify-content: space-between; display: flex; width: 100%;">
        <div class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6" style="justify-content: flex-start; display: flex; align-items: center; margin-left: 0%; width: 100%;">
        </div>

        <div class="vs-col vs-pagination--mb vs-xs-12 vs-sm-12 vs-lg-6" style="justify-content: flex-end; display: flex; align-items: center; margin-left: 0%; width: 100%;">
            <div class="con-vs-pagination vs-pagination-primary">
                <nav class="vs-pagination--nav">
                    <!-- <button class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev" @click="toPrevPage">
                        <i class="vs-icon notranslate icon-scale material-icons null">chevron_left</i>
                    </button>

                    <ul class="vs-pagination--ul">
                        <span v-if="total < 6">
                            <li class="item-pagination vs-pagination--li" v-for="page in total" :key="page" :class="{'is-current': page==currentPage}" @click="pageClick(page)">
                                {{page}}
                            </li>
                        </span>
                        <span v-else>
                            <li class="item-pagination vs-pagination--li">1</li>

                            <li class="item-pagination vs-pagination--li" v-if="currentPage != 2">...</li>

                            <li class="item-pagination vs-pagination--li"></li>

                            <li class="item-pagination vs-pagination--li" v-if="currentPage != total-1">...</li>

                            <li class="item-pagination vs-pagination--li">{{total}}</li>

                        </span>
                    </ul>

                    <button class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" @click="toNextPage">
                        <i class="vs-icon notranslate icon-scale material-icons null">chevron_right</i>
                    </button> -->

                    <button class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev text-xs rounded-item bg-transparent font-bold text-sm" @click="onClickFirstPage" :disabled="isInFirstPage">
                        First
                    </button>

                    <button class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev rounded-item bg-white shadow-md" @click="onClickPreviousPage" :disabled="isInFirstPage">
                        <i class="vs-icon notranslate icon-scale material-icons null">chevron_left</i>
                    </button>

                    <ul class="vs-pagination--ul bg-transparent">
                        <li class="item-pagination vs-pagination--li rounded-item bg-white shadow-md mx-1" v-for="page in pages" :key="page.name" :disabled="page.isDisabled" @click="onClickPage(page.name)" :class="{'is-current': page.name==currentPage}">
                            {{page.name}}
                        </li>
                    </ul>

                    <button class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next rounded-item bg-white shadow-md" @click="onClickNextPage" :disabled="isInLastPage">
                        <i class="vs-icon notranslate icon-scale material-icons null">chevron_right</i>
                    </button>

                    <button class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next text-xs rounded-item bg-transparent font-bold text-sm" @click="onClickLastPage" :disabled="isInLastPage">
                        Last
                    </button>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'custom-pagination',
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 3
        },
        totalPages: {
            type: Number,
            required: true
        },
        // total: {
        //     type: Number,
        //     required: true
        // },
        currentPage: {
            type: Number,
            required: true
        }
    },
    data() {
        // console.log(this.currentPage);
        return {

        }
    },
    computed: {
        startPage() {
            // When on the first page
            if (this.currentPage === 1) {
                return 1;
            }
            // When on the last page
            if (this.currentPage === this.totalPages) {
                if(this.totalPages > this.maxVisibleButtons) {
                    return this.totalPages - this.maxVisibleButtons + 1;
                }
            }
            // When in between
            return this.currentPage - 1;
        },
        pages() {
            const range = [];

            for (let i = this.startPage; i <= Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages); i++) {
                range.push({
                    name: i,
                    isDisabled: i === this.currentPage
                });
            }

            return range;
        },
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        },
    },
    methods: {
        // pageClick(page) {
        //     this.$emit('click', page);
        // },
        // toNextPage() {
        //     this.$emit('toNextPage');
        // },
        // toPrevPage() {
        //     this.$emit('toPrevPage');
        // },
        onClickFirstPage() {
            this.$emit('pageChanged', 1);
        },
        onClickPreviousPage() {
            this.$emit('pageChanged', this.currentPage - 1);
        },
        onClickPage(page) {
            this.$emit('pageChanged', page);
        },
        onClickNextPage() {
            this.$emit('pageChanged', this.currentPage + 1);
        },
        onClickLastPage() {
            this.$emit('pageChanged', this.totalPages);
        }
    }
}
</script>
